import { PurchasePaymentChannelEnum } from './purchases'

export interface ICartItemDiscount {
  code: string
  name: string
  type: 'PROMO_CODE' | 'AUTO_DISCOUNT'
  amountOff: number
}

export interface ICartItem {
  id: string
  name: string
  description: string
  category:
    | 'TV_SHOW'
    | 'TV_SHOW_SET'
    | 'SEASON'
    | 'EPISODE'
    | 'VOD'
    | 'VOD_SET'
    | 'CHANNEL'
    | 'CHANNEL_SET'
    | 'LIVE_EVENT'
  originalPrice: number
  price: number
  availabilityStartTime: string
  availabilityEndTime: string
  discounts: Array<ICartItemDiscount>
}

export interface ICartCoupon {
  id: string
  code: string
  name: string
}

export interface ICartInvoice {
  provider: 'EZPAY'
  ezPay: {
    type:
      | 'DONATION'
      | 'E_MOBILE_BARCODE_CARRIER'
      | 'E_CITIZEN_DIGITAL_CERTIFICATE_CARRIER'
      | 'E_EZPAY_MEMBER_CARRIER'
    code: string
  }
}

export interface ICartCreditCardData {
  creditCardId: number
  number: string
  dataDescriptor: string
  dataValue: string
  saveCreditCard: boolean
}

export type CartPaymentMethod = 'FREE' | 'CREDIT_CARD' | 'CONVENIENT_STORE'
export enum CartPaymentMethodEnum {
  CREDIT_CARD = 'CREDIT_CARD',
  FREE = 'FREE',
  CONVENIENT_STORE = 'CONVENIENT_STORE',
}

export interface ICartPayment {
  cartPaymentChannel: PurchasePaymentChannelEnum
  cartPaymentMethod: CartPaymentMethod
  cartCreditCardData: ICartCreditCardData
}

export interface ICartFullInfo {
  orderNumber: string
  orderTime: string
  items: Array<ICartItem>
  coupons: Array<ICartCoupon>
  invoice: ICartInvoice
  payment: ICartPayment
  status: 'CHECKOUT' | 'EMPTY' | 'SHOPPING'
  total: number
  currency: string
}

export interface IANetPayRequest {
  purchaseNumber: string
  customerProfileId: string
  paymentProfileId: string
  dataDescriptor: string
  dataValue: string
}

export interface IGravyEmbedOptions {
  purchaseNumber: string
  gr4vyId: string
  environment: string
  token: string
  buyerId: string
  amount: number
  currency: string
  country: string
  intent?: string
  externalIdentifier: string
  metadata: { [key: string]: string }
}

export interface ICartConfirmPurchaseInfo {
  payment: {
    channel: PurchasePaymentChannelEnum
    method: CartPaymentMethod
    gr4vyEmbedOptions?: IGravyEmbedOptions
    aNetPayRequest?: IANetPayRequest
  }
}

export interface IFinalProcessPayment {
  payment: {
    channel: PurchasePaymentChannelEnum
    method: CartPaymentMethod
    aNetPayRequest?: {
      purchaseNumber: string
      customerProfileId: string
      paymentProfileId: string
      dataDescriptor: string
      dataValue: string
    }
    gr4vyPayRequest?: {
      purchaseNumber: string
      transactionId: string
      transactionStatus: string
      paymentMethodId: string | null
    }
  }
}
